const Marionette = require('backbone.marionette'),
    template = require('./requestAccessView.hbs'),
    M = require('shared/messages/messages'),
    ajaxRequest = require('shared/util/ajaxRequest'),
    RequestAccessModel = require('./requestAccessModel');
require('backbone.stickit');
require('select2');

module.exports = Marionette.View.extend({
    className: 'container',
    template: template,
    templateContext: function () {
        return {
            succeeded: this.succeeded,
            M: M,
        };
    },
    ui: {
        cellCarrier: '#cellCarrier',
        usaState: '#usaState',
        country: '#country',
        language: '#language',
        timeZone: '#timeZone',
        requestedCompany: '#requestedCompany',
        requestedAsset: '#requestedAsset',
        requestedWells: '#requestedWells',
        saveBtn: '#saveBtn',
    },
    events: {
        'click @ui.saveBtn': 'onPreSave',
    },
    behaviors: {
        AutoFocus: {},
        WaitButton: {},
        LockForm: {},
        HandleServerValidationError: {},
        SaveModel: {
            returnUrl: false
        }
    },
    initialize: function (options) {
        this.cellCarriers = options.cellCarriers;
        this.countries = options.countries;
        this.usaStates = options.usaStates;
        this.languages = options.languages;
        this.timeZones = options.timeZones;
        this.model = new RequestAccessModel({
            passwordPolicy: options.defaultPasswordPolicy,
            companyId: null,
            'userSetting.country': 'United States',
        });
        Backbone.Validation.bind(this);
    },
    onRender: function () {
        this.stickit();
    },
    onDomRefresh: function () {
        this.ui.country.select2({
            placeholder: M.select('a-country'),
            allowClear: true
        });
        this.ui.usaState.select2({
            placeholder: M.select('a-state'),
            allowClear: true
        });
        this.ui.cellCarrier.select2({
            placeholder: M.select('a-cell-carrier'),
            allowClear: true
        });
        this.ui.language.select2({
            placeholder: M.select('a-language'),
            allowClear: true
        });
        this.ui.timeZone.select2({
            placeholder: M.select('a-time-zone'),
            allowClear: true
        });
    },
    isUnitedStates: function () {
        return this.model.get('userSetting.country') === 'United States';
    },
    onPreSave: function (e) {
        if (!this.model.isValid(true)) {
            return;
        }
        // Store requested company, asset and wells into user note.  The line break is for readability.
        if (this.ui.requestedCompany.val() || this.ui.requestedAsset.val() || this.ui.requestedWells.val()) {
            let requestedCompany = `Requested Company: ${this.ui.requestedCompany.val()}\n`;
            let requestedAsset = `Requested Asset: ${this.ui.requestedAsset.val()}\n`;
            let requestedWells = `Requested Well: ${this.ui.requestedWells.val()}\n`;
            this.model.set('note', (requestedCompany + requestedAsset + requestedWells));
        }
        let promise = ajaxRequest({
            type: 'POST',
            url: './api/requestAccess/user/isEmailExists',
            data: JSON.stringify(this.model)
        });
        promise.done(function (response) {
            let message = M.requestAccessEmailAlreadyExists(this.model.get('email'));
            if (!response || confirm(message)) {
                this.onSave(e)
                    .done(this.showSuccessMessage.bind(this));
            }
        }.bind(this));
    },
    showSuccessMessage: function () {
        this.succeeded = true;
        this.render();
        // Quick and dirty fix for the fact that, after successful submit, the screen would otherwise still be scrolled to where the Save button was located, and the success message is so small that it's mostly obscured by the top of the browser, even more so when the Success toast is still visible.
        // Well we eliminated ie-height-fix, and this is still needed, because the browser content still exceeds the viewport.  My guess now is that it's because we're still rendering some/all of the form, just hiding it.  
        // Again, when we refactor the login page, we'll take another run at making it so we don't need this. 
        window.scrollTo(0, 0);
    },
    bindings: {
        '#firstName': 'firstName',
        '#lastName': 'lastName',
        '#cellNumber': 'cellNumber',
        '#email': 'email',
        '#streetAddress': 'userSetting.streetAddress',
        '#city': 'userSetting.city',
        '#province': 'userSetting.province',
        '#userName': 'userName',
        '#password': 'password',
        '#passwordConfirmation': 'passwordConfirmation',
        '#cellCarrier': {
            observe: 'cellCarrierId',
            selectOptions: {
                collection: function () {
                    return this.cellCarriers;
                },
                labelPath: 'name',
                valuePath: 'id',
                defaultOption: {
                    value: null,
                    label: null
                }
            }
        },
        '#country': {
            observe: 'userSetting.country',
            selectOptions: {
                collection: function () {
                    return this.countries;
                },
                labelPath: 'name',
                valuePath: 'name',
                defaultOption: {
                    value: null,
                    label: null
                }
            }
        },
        '#usaState': {
            observe: 'userSetting.state',
            selectOptions: {
                collection: function () {
                    return this.usaStates;
                },
                labelPath: 'name',
                valuePath: 'name',
                defaultOption: {
                    value: null,
                    label: null
                }
            }
        },
        '#provinceSection': {
            observe: 'userSetting.country',
            visible: function (value, options) {
                return !this.isUnitedStates();
            }
        },
        '#stateSection': {
            observe: 'userSetting.country',
            visible: function (value, options) {
                return this.isUnitedStates();
            }
        },
        '#language': {
            observe: 'userSetting.language',
            onGet: function (value) {
                return value || 'en';
            },
            selectOptions: {
                collection: function () {
                    return this.languages;
                },
                labelPath: 'name',
                valuePath: 'isoCode',
            },
        },
        '#timeZone': {
            observe: 'timeZoneId',
            selectOptions: {
                collection: function () {
                    return this.timeZones;
                },
                labelPath: 'name',
                valuePath: 'id',
                defaultOption: {
                    value: null,
                    label: null
                }
            },
        },
    }
});
